import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { EmailStructure } from 'src/app/core/interfaces/emailStructure';

@Component({
  selector: 'app-email-item',
  templateUrl: './email-item.component.html',
  styleUrls: ['./email-item.component.scss']
})
export class EmailItemComponent implements OnInit {

  @Input() email: EmailStructure;
  @Input() showDeleteButton: boolean = false;
  @Output() deleteEmailEvent: EventEmitter<EmailStructure> = new EventEmitter();
  constructor() { }

  ngOnInit() {
  }

  onDeleteEmail(): void {
    this.deleteEmailEvent.emit(this.email);
  }

}
